export enum SubscriptionType {
  FREE_TRIAL = 'Free Trial',
  ENTERPRISE = 'Enterprise',
}
